import { GridSortDirection } from '@mui/x-data-grid';

import { _request, APIBasePaginatedResponse, APIBaseResponse,APIMethod } from '..';
import { buildQueryParams } from '../apiHelpers';
import { UserTenantMembershipStatusProps } from '../TenantUserMembership/TenantUserMembershipApiTypeDefs';

const PROFILES_PATH_PREFIX = '/profiles';
const TENANTS_PATH_PREFIX = '/tenants';
const USER_CLAIM_MEMBERSHIP_PATH_PREFIX = 'userclaimmemberships';

export interface IUser {
    userId: string;
    oasysId?: string;
    profile: {
        firstName: string;
        lastName: string;
        principalName: string;
        companyKey: string;
        email: string;
    }
}

export type APIClaimUserMembershipGetParams = {
    tenantId: string;
    claimId: string;
    search?: string;
    skip?: number;
    take?: number;
    sortKey?: string;
    sortOrder?: GridSortDirection;
    rowsCount?: number;
    signal?: AbortSignal;
    retries?: number;
    status?: string[];
};

export type ClaimUserMembershipGetPaginatedResponse =
    IUser & UserTenantMembershipStatusProps & {
    claimId: string;
    claimName: string;
    value: string;
    status: string;
    startDate: string;
    endDate:string;
}

export type APIClaimUserMembershipPostParams = {
    tenantId: string;
    claimId: string;
    userId: string;
    value: string;
};

export type APIClaimUserMembershipPutParams = {
    tenantId: string;
    claimId: string;
    userId: string;
    value: string;
};

export type APIClaimUserMembershipDeleteParams = {
    tenantId: string;
    claimId: string;
    userId: string;
};

export type APIClaimUserMembershipPostResponse = APIBaseResponse<''>;

export type APIClaimUserMembershipPutResponse = APIBaseResponse<''>;

export type APIClaimUserMembershipGetResponse = APIBasePaginatedResponse<Array<ClaimUserMembershipGetPaginatedResponse>>;

export const APIClaimUserMembershipGetList: APIMethod<APIClaimUserMembershipGetParams, APIClaimUserMembershipGetResponse> = params => {
    const queryParams = buildQueryParams(params, [{ key : 'status' }]);
    const endPoint = `${PROFILES_PATH_PREFIX}${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}`;
    const requestPath = `${endPoint}` + (queryParams && `?${queryParams}`);
    return _request('GET', requestPath, undefined, params.signal, params.retries);
};

export const APIClaimUserMembershipPost: APIMethod<APIClaimUserMembershipPostParams, APIClaimUserMembershipPostResponse> = params => {
    return _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}`, params);
};

export const APIClaimUserMembershipPut: APIMethod<APIClaimUserMembershipPutParams, APIClaimUserMembershipPutResponse> = params => {
    return _request('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}`, params);
};

export const APIClaimUserMembershipDelete: APIMethod<APIClaimUserMembershipDeleteParams, APIBaseResponse> = params => {
    const queryParams = buildQueryParams(params);
    const endPoint = `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}`;
    const requestPath = `${endPoint}` + (queryParams && `?${queryParams}`);
    return _request('DELETE', requestPath);
};
